import { baseConfig } from '../../config/algolia';
import type { SortOrder } from '../../types/search';

const { sort_orders } = baseConfig as { sort_orders?: Array<SortOrder> };

export const getSortOrderLabel = (sortBy: string | undefined, order: 'asc' | 'desc' | undefined): string => {
  if (!sortBy) return 'Best Match';

  const match = sort_orders?.find(so => so.key === sortBy && so[order ?? 'asc']?.active);

  return match?.[order ?? 'asc']?.title ?? sortBy;
};

export const getSortLabelForIndex = (currentIndex: string | undefined, baseIndex: string): string => {
  if (!currentIndex || !baseIndex || currentIndex === baseIndex) return 'Best Match';
  const suffix = currentIndex.startsWith(`${baseIndex}_`) ? currentIndex.slice(baseIndex.length + 1) : '';
  if (!suffix) return 'Best Match';
  const parts = suffix.split('_');
  const order = parts.pop();
  if (order !== 'asc' && order !== 'desc') return 'Best Match';
  const key = parts.join('_');
  return getSortOrderLabel(key, order);
};
